import { render, staticRenderFns } from "./GreenTextWithPlus.vue?vue&type=template&id=11f34fb8&scoped=true"
import script from "./GreenTextWithPlus.vue?vue&type=script&lang=js"
export * from "./GreenTextWithPlus.vue?vue&type=script&lang=js"
import style0 from "./GreenTextWithPlus.vue?vue&type=style&index=0&id=11f34fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f34fb8",
  null
  
)

export default component.exports